import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Card,
  Table,
  Select,
  Input,
  Button,
  Tooltip,
  Modal,
  Tag,
  DatePicker,
} from "antd";
import {
  API_BASE,
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";
import { formateDateDbT } from "../../utils/dateUtil";
import {
  req_page_usm_space_management_log,
  req_downloadfile_usm_space_management_log,
} from "../../api";

const { RangePicker } = DatePicker;

class SpaceManagementHistory extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: 0,
    loading: false,
    userLevel: "NORMAL",
    items: [],
    courseRooms: [],
    storageGoods: [],
    item: {},
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",
    startDate: "",
    endDate: "",

    isShowConfigModal: false,
    isShowAddModal: false,
    isShowEditModal: false,
    isShowCourseModal: false,
    isShowStorageModal: false,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    this.api_page_items(1);
  }

  // 遠端數據處理 //////////////////////////////////////////////
  api_page_items = async (current) => {
    const { pageSize } = this.state.pagination;
    const {
      searchField,
      searchValue,
      columnSort,
      orderBy,
      filterStatus,
      startDate,
      endDate,
    } = this.state;
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true, items: [] });
    const result = await req_page_usm_space_management_log(
      userLevel,
      userCode,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      startDate,
      endDate,
      token
    );

    // console.log(result);
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination, loading: false });
      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination, loading: false });
    }
  };

  api_downloadfile_items = async () => {
    const {
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      startDate,
      endDate,
    } = this.state;
    const { token, userCode } = this.props.user;

    const fileUrl = await req_downloadfile_usm_space_management_log(
      userLevel,
      userCode,
      searchField,
      searchValue,
      filterStatus,
      startDate,
      endDate,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "歷程",
        width: 10,
        fixed: "left",
        render: (item) => {
          const { LastChangeStatus } = item;
          return (
            <div style={{ textAlign: "center" }}>
              <Tag
                color={this.style_switch_color_tag(
                  "LOGSTATUS",
                  LastChangeStatus
                )}
              >
                {LastChangeStatus}
              </Tag>
            </div>
          );
        },
      },
      {
        title: "空間編號",
        width: 20,
        fixed: "left",
        render: (item) => {
          const { SpaceCode, Monitoring, ApplyPhysicalPlate } = item;
          return (
            <>
              {SpaceCode}
              {Monitoring === "N" ? (
                <Tooltip title="取消統計功能">
                  {" "}
                  <i className="fa fa-eye-slash" style={{ color: "red" }}></i>
                </Tooltip>
              ) : (
                ""
              )}
              {ApplyPhysicalPlate === "Y" ? (
                <Tooltip title="實體門牌申請">
                  {" "}
                  <i className="fa fa-tag" style={{ color: "blue" }}></i>
                </Tooltip>
              ) : (
                ""
              )}
            </>
          );
        },
      },
      {
        title: "異動時間",
        width: 20,
        render: (item) => {
          const { LastChangeDateTime } = item;
          return (
            <div style={{ textAlign: "center" }}>
              {formateDateDbT(LastChangeDateTime)}
            </div>
          );
        },
      },
      {
        title: "空間中文名稱",
        dataIndex: "SpaceStandardTwName",
        width: 30,
      },
      {
        title: "空間英文名稱",
        dataIndex: "SpaceStandardEnName",
        width: 30,
      },
      {
        title: "保管單位",
        dataIndex: "ShortDepartmentTwName",
        width: 30,
      },
      {
        title: "保管人",
        dataIndex: "CustodianTwName",
        width: 20,
      },
      {
        title: "異動者",
        dataIndex: "LastChangeUserName",
        width: 20,
      },
    ];
  };

  style_switch_color_tag(name, value) {
    let ans = "#87d068";
    switch (name) {
      case "LOGSTATUS":
        switch (value) {
          case "新增":
            ans = "green";
            break;
          case "修改":
            ans = "orange";
            break;
          case "刪除":
            ans = "cyan";
            break;
          default:
            // OTHER
            break;
        }
        return ans;
      default:
        // OTHER
        break;
    }
  }

  // 操作互動處理 //////////////////////////////////////////////
  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_show_ui_modal = (type, item) => {
    //console.log(item);
    const { SpaceCode } = item;
    switch (type) {
      case "ADD":
        this.setState({ isShowAddModal: true });
        break;
      case "EDIT":
        this.setState({ isShowEditModal: true, item });
        break;
      case "DELETE":
        const { Uid } = item;
        Modal.confirm({
          title: `您確定刪除此空間資訊`,
          onOk: () => {
            this.api_delete_item(Uid);
          },
        });
        break;
      case "EXPORT":
        this.api_downloadfile_items();
        break;
      case "CONFIG":
        this.setState({ isShowConfigModal: true });
        break;
      case "COURSEROOMSLIST":
        this.api_list_course_rooms(SpaceCode);
        break;
      case "STORAGEGOODSLIST":
        this.api_list_storage_goods(SpaceCode);
        break;
      default:
    }
    this.setState({ item: item });
  };

  handle_date_change = (value, dateString) => {
    this.setState({ startDate: dateString[0], endDate: dateString[1] });
  };

  //////////////////////////////////////////////////////////
  render() {
    const { loading, items, pagination, searchField, searchValue } = this.state;
    const title = (
      <>
        <RangePicker format="YYYY-MM-DD" onChange={this.handle_date_change} />
        <Select
          value={searchField}
          style={{ width: 120 }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">搜索條件</Select.Option>
          <Select.Option value="BuildingName">所在大樓</Select.Option>
          <Select.Option value="Floor">樓層</Select.Option>
          <Select.Option value="SpaceCode">空間編號</Select.Option>
          <Select.Option value="SpaceStandardTwName">
            空間中文名稱
          </Select.Option>
          <Select.Option value="ShortDepartmentTwName">保管單位</Select.Option>
          <Select.Option value="CustodianTwName">保管人</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 100, margin: "0 5px" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>{" "}
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search" style={{ paddingRight: "4px" }}></i> 查詢
        </Button>{" "}
        <Button
          type="primary"
          onClick={() => this.handle_show_ui_modal("EXPORT", {})}
        >
          <i className="fa fa-file-excel" style={{ paddingRight: "4px" }}></i>{" "}
          匯出
        </Button>
        <p></p>
      </>
    );
    return (
      <>
        {title}
        <Card>
          <Table
            bordered
            scroll={{ x: 800, y: 380 }}
            loading={loading}
            rowKey="Uid"
            columns={this.columns}
            dataSource={items}
            onChange={this.handle_table_change}
            pagination={{
              ...pagination,
              responsive: true,
              showQuickJumper: true,
              showSizeChanger: true,
              pageSizeOptions: [5, 10, 20, 50, 100],
              // onChange: this.api_page_applycase,
              onShowSizeChange: this.handle_page_size_change,
            }}
          />
        </Card>
      </>
    );
  }
}
export default connect(
  (state) => ({ user: state.user }),
  {}
)(SpaceManagementHistory);
